import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      setSent(true);
      setLoading(false);
    } catch { setError('Connection error'); setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand"><h1>Retail Alpha</h1><p>AI-Powered Alpha for Retail Investors</p></div>
        <h2>Reset Password</h2>
        {sent ? (
          <>
            <div className="auth-success">If an account exists with that email, a password reset link has been sent. Check your inbox.</div>
            <Link to="/login"><button className="auth-btn secondary">Back to Sign In</button></Link>
          </>
        ) : (
          <>
            <p className="auth-subtitle">Enter your email and we'll send you a link to reset your password.</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="auth-field">
                <label>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required autoFocus />
              </div>
              <button className="auth-btn" type="submit" disabled={loading}>{loading ? 'Sending...' : 'Send Reset Link'}</button>
            </form>
            <div className="auth-footer">
              <Link to="/login" className="auth-link">Back to Sign In</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
